import React, { FC } from 'react';
import { Formik } from 'formik';
import { Form, FormItem, Input } from 'formik-antd';
import { defaultFormLayout } from 'common/config/formLayout';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { object } from 'yup';
import { FormikOnSubmit } from 'lib/formik.utils';

import {
  dateOfBirthValidationSchema,
  firstNameValidationSchema,
  genderValidationSchema,
  idNumberValidationSchema,
  lastNameValidationSchema,
  phoneNumberValidationSchema,
  phoneNumberPrefixCodeValidation,
} from 'common/config/validationSchema';
import { ProfileOwnerFormModel } from 'models/user';
import { UserStatus } from 'models/userStatus';

const emptyInitialValues: ProfileOwnerFormModel = {
  partner: '',
  dateOfBirth: '',
  email: '',
  firstName: '',
  gender: '',
  idNumber: '',
  lastName: '',
  phoneNumber: '',
  prefixCode: '',
  id: 0,
  status: UserStatus.Active,
  userId: 0,
};

export interface ProfileOwnerFormProps {
  onSubmit: FormikOnSubmit<ProfileOwnerFormModel>;
  initialValues: ProfileOwnerFormModel;
  loading?: boolean;
}
export const ProfileOwnerForm: FC<ProfileOwnerFormProps> = ({
  onSubmit,
  loading = false,
  initialValues,
}) => {
  const intlMessage = useFormatMessage();

  const validationSchema = object().shape(
    {
      firstName: firstNameValidationSchema(intlMessage),
      lastName: lastNameValidationSchema(intlMessage),
      dateOfBirth: dateOfBirthValidationSchema(intlMessage),
      gender: genderValidationSchema(intlMessage),
      idNumber: idNumberValidationSchema(intlMessage),
      phoneNumber: phoneNumberValidationSchema(intlMessage),
      prefixCode: phoneNumberPrefixCodeValidation(intlMessage),
    },
    [['prefixCode', 'phoneNumber']]
  );

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues || emptyInitialValues}
      onSubmit={onSubmit}
    >
      <Form {...defaultFormLayout}>
        <FormItem
          label={intlMessage({ id: 'person.firstName' })}
          name="firstName"
        >
          <Input name="firstName" disabled />
        </FormItem>

        <FormItem
          label={intlMessage({ id: 'person.lastName' })}
          name="lastName"
        >
          <Input name="lastName" disabled />
        </FormItem>

        <FormItem label={intlMessage({ id: 'email' })} name="email">
          <Input name="email" readOnly disabled />
        </FormItem>
      </Form>
    </Formik>
  );
};
